const defaultConfig = {
  aws_project_region: 'ap-southeast-2',
  aws_cognito_region: 'ap-southeast-2',
  aws_appsync_region: 'ap-southeast-2',
  oauth: {},
  aws_user_files_s3_bucket_region: 'ap-southeast-2',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
};

const awsenvconfig = {
  prod: {
    ...defaultConfig,
    aws_cognito_identity_pool_id: 'ap-southeast-2:c7d75448-c734-4261-b1db-7a2ada4dd41c',
    aws_user_pools_id: 'ap-southeast-2_BoRm9vNUB',
    aws_user_pools_web_client_id: '6p8gdkqb0p4u99l04ls853798j',
    aws_appsync_graphqlEndpoint: 'https://kxfmvz5mzbfw5ia3cs5u7jymqm.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-prod',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'auth.sendpayments.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://portal.sendpayments.com',
      redirectSignOut: 'https://portal.sendpayments.com',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
  },
  uat: {
    ...defaultConfig,
    aws_cognito_identity_pool_id: 'ap-southeast-2:e1ae5a6c-cdf0-4388-9fdb-7084712b3ef6',
    aws_user_pools_id: 'ap-southeast-2_edo0y6SW7',
    aws_user_pools_web_client_id: 'jeul4cbhdu276nuse3e3bno2r',
    aws_appsync_graphqlEndpoint: 'https://apo47khi4bfyhm5wgytxvc7wwy.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-uat',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-uat.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-uat.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-uat.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-uat.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-uat.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-uat.env.sendpayments.com/',
      redirectSignOut: 'https://localhost:9000/,https://portal-uat.env.sendpayments.com/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
  },
  cat: {
    ...defaultConfig,
    aws_cognito_identity_pool_id: 'ap-southeast-2:5e3fe9d0-d0e6-4197-b70a-39154be0812b',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_kGFcBsK55',
    aws_user_pools_web_client_id: '11fdvftmc2jdrd11t8pk9nkn1j',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-cat.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-cat.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-cat.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-cat.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-cat.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-cat.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-cat.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_appsync_graphqlEndpoint: 'https://pmx66njq7jd7dmt3xw24uliyty.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-cat',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
  },
  demo: {
    ...defaultConfig,
    aws_cognito_identity_pool_id: 'ap-southeast-2:65ebff70-9d8f-4152-999b-a49d5cf64b88',
    aws_user_pools_id: 'ap-southeast-2_8e3ftmozH',
    aws_user_pools_web_client_id: '5rpdrs655dc7t7hfe9bvrh1gt5',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api.demo.sendpayments.com',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-demo.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal.demo.sendpayments.com/',
      redirectSignOut: 'https://localhost:9000/,https://portal.demo.sendpayments.com/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_appsync_graphqlEndpoint: 'https://65pop2msevfwjgg4huz3ujh2vi.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-demo',
  },
  tmozuat: {
    ...defaultConfig,
    aws_cognito_identity_pool_id: 'ap-southeast-2:e1ae5a6c-cdf0-4388-9fdb-7084712b3ef6',
    aws_user_pools_id: 'ap-southeast-2_edo0y6SW7',
    aws_user_pools_web_client_id: 'jeul4cbhdu276nuse3e3bno2r',
    aws_appsync_graphqlEndpoint: 'https://apo47khi4bfyhm5wgytxvc7wwy.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-uat',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-uat.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-uat.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-uat.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-uat.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-uat.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-uat.env.sendpayments.com/',
      redirectSignOut: 'https://localhost:9000/,https://portal-uat.env.sendpayments.com/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
  },
  tmozqa: {
    ...defaultConfig,
    aws_cognito_identity_pool_id: 'ap-southeast-2:31b3d2aa-4de2-4a59-8c33-4c5e2876ca92',
    aws_user_pools_id: 'ap-southeast-2_zfuRrya6H',
    aws_user_pools_web_client_id: 'q3vhmqbhm1h5jc3k7fhkpt6l2',
    aws_appsync_graphqlEndpoint: 'https://msxltucavvgezoelqacblrecxa.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-release',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-release.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-release.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-tmozqa.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-tmozqa.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-uat.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-uat.env.sendpayments.com/',
      redirectSignOut: 'https://localhost:9000/,https://portal-uat.env.sendpayments.com/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
  },
  tmozprod: {
    ...defaultConfig,
    aws_cognito_identity_pool_id: 'ap-southeast-2:c7d75448-c734-4261-b1db-7a2ada4dd41c',
    aws_user_pools_id: 'ap-southeast-2_BoRm9vNUB',
    aws_user_pools_web_client_id: '6p8gdkqb0p4u99l04ls853798j',
    aws_appsync_graphqlEndpoint: 'https://kxfmvz5mzbfw5ia3cs5u7jymqm.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-prod',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-tmozprod.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-tmozprod.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'auth.sendpayments.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://portal.sendpayments.com',
      redirectSignOut: 'https://portal.sendpayments.com',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
  },
  reskinuat: {
    ...defaultConfig,
    aws_cognito_identity_pool_id: 'ap-southeast-2:e1ae5a6c-cdf0-4388-9fdb-7084712b3ef6',
    aws_user_pools_id: 'ap-southeast-2_edo0y6SW7',
    aws_user_pools_web_client_id: 'jeul4cbhdu276nuse3e3bno2r',
    aws_appsync_graphqlEndpoint: 'https://apo47khi4bfyhm5wgytxvc7wwy.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-uat',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-uat.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-uat.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-uat.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-uat.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-uat.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-uat.env.sendpayments.com/',
      redirectSignOut: 'https://localhost:9000/,https://portal-uat.env.sendpayments.com/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
  },
  reskinqa: {
    ...defaultConfig,
    aws_cognito_identity_pool_id: 'ap-southeast-2:31b3d2aa-4de2-4a59-8c33-4c5e2876ca92',
    aws_user_pools_id: 'ap-southeast-2_zfuRrya6H',
    aws_user_pools_web_client_id: 'q3vhmqbhm1h5jc3k7fhkpt6l2',
    aws_appsync_graphqlEndpoint: 'https://msxltucavvgezoelqacblrecxa.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-release',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-release.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-release.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-uat.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-uat.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-release.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-release.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-release.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
  },
  reskinprod: {
    ...defaultConfig,
    aws_cognito_identity_pool_id: 'ap-southeast-2:c7d75448-c734-4261-b1db-7a2ada4dd41c',
    aws_user_pools_id: 'ap-southeast-2_BoRm9vNUB',
    aws_user_pools_web_client_id: '6p8gdkqb0p4u99l04ls853798j',
    aws_appsync_graphqlEndpoint: 'https://kxfmvz5mzbfw5ia3cs5u7jymqm.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-prod',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'auth.sendpayments.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://portal.sendpayments.com',
      redirectSignOut: 'https://portal.sendpayments.com',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
  },
  release: {
    ...defaultConfig,
    aws_cognito_identity_pool_id: 'ap-southeast-2:31b3d2aa-4de2-4a59-8c33-4c5e2876ca92',
    aws_user_pools_id: 'ap-southeast-2_zfuRrya6H',
    aws_user_pools_web_client_id: 'q3vhmqbhm1h5jc3k7fhkpt6l2',
    aws_appsync_graphqlEndpoint: 'https://msxltucavvgezoelqacblrecxa.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-release',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-release.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-release.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-release.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-release.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-release.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-release.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-release.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
  },
  polaris: {
    ...defaultConfig,
    aws_cognito_identity_pool_id: 'ap-southeast-2:043d1d59-5782-4e11-91c3-135535ae3fed',
    aws_user_pools_id: 'ap-southeast-2_9YAKGUxCv',
    aws_user_pools_web_client_id: '4o87rq1e6jc51kudhf64dvajoc',
    aws_appsync_graphqlEndpoint: 'https://tnkgl7yi2nh2touiyccbimbwj4.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-polaris',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-polaris.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-polaris.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-polaris.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-polaris.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-polaris.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-polaris.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-polaris.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
  },
  uranus: {
    ...defaultConfig,
    aws_cognito_identity_pool_id: 'ap-southeast-2:e3e6aa8f-1530-43dd-aec5-d042198e5a15',
    aws_user_pools_id: 'ap-southeast-2_xsylioVvp',
    aws_user_pools_web_client_id: '6l7vkj08rt4d0gq64ktn622cts',
    aws_appsync_graphqlEndpoint: 'https://l66enxxbg5dczbwp4n2zmiw4e4.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-uranus',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-uranus.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-uranus.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-uranus.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-uranus.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-uranus.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-uranus.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-uranus.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
  },
  krypton: {
    ...defaultConfig,
    aws_cognito_identity_pool_id: 'ap-southeast-2:d8897b7e-da69-4bfc-91ca-a8a71cab540e',
    aws_user_pools_id: 'ap-southeast-2_04SqZfprD',
    aws_user_pools_web_client_id: '2ctl2qldtj3v03pa4u0rnfpeo0',
    aws_appsync_graphqlEndpoint: 'https://prw2stmrgrfjzotk2326nvnvwi.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-krypton',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-krypton.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-krypton.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-krypton.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-krypton.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-krypton.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-krypton.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-krypton.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
  },
  canis: {
    ...defaultConfig,
    aws_cognito_identity_pool_id: 'ap-southeast-2:256deb3e-fa04-432c-ac79-26c6c29b3eca',
    aws_user_pools_id: 'ap-southeast-2_7cESztspD',
    aws_user_pools_web_client_id: '25dl2r8et8t9rj3rsnei0rjr3p',
    aws_appsync_graphqlEndpoint: 'https://wjo7mnzz2zgsjpvoa25jfsbu5q.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-canis',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-canis.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-canis.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-canis.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-canis.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-canis.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-canis.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-canis.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
  },
  saga: {
    ...defaultConfig,
    aws_cognito_identity_pool_id: 'ap-southeast-2:be94a96d-356c-4981-9d31-651359e0c026',
    aws_user_pools_id: 'ap-southeast-2_U6hCGqFgR',
    aws_user_pools_web_client_id: '3msvl81oopv290dkqbbekqvhsn',
    aws_appsync_graphqlEndpoint: 'https://kn6ee4jncvcdxiqsmja6acmnee.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-saga',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-saga.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-saga.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-saga.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-saga.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-saga.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-saga.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-saga.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
  },
  sirius: {
    aws_project_region: 'ap-southeast-2',
    aws_cognito_identity_pool_id: 'ap-southeast-2:ec7d5e21-6f7c-48b5-956e-b5926185288f',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_neJIlD4Xn',
    aws_user_pools_web_client_id: '7mmmn8tfm5q7k8fl6v0ml75c0j',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-sirius.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-sirius.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-sirius.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-sirius.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-sirius.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-sirius.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-sirius.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_appsync_graphqlEndpoint: 'https://4ht47w6t2nhhroofxjbbtxqfcq.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-sirius',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
  },
  luna: {
    aws_project_region: 'ap-southeast-2',
    aws_cognito_identity_pool_id: 'ap-southeast-2:1cbfdf72-3861-46d8-92f8-3373b8fc13f3',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_LkOAre37M',
    aws_user_pools_web_client_id: '76le7ontbj67q87u1sla9dlq8j',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-luna.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-luna.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-luna.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-luna.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-luna.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-luna.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-luna.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_appsync_graphqlEndpoint: 'https://jqblskp3w5ds5el6oxhilfpz5a.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-luna',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
  },
  titan: {
    aws_project_region: 'ap-southeast-2',
    aws_cognito_identity_pool_id: 'ap-southeast-2:a82c20c0-4da9-4357-8d03-6901e852e609',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_oQT9c9Z8n',
    aws_user_pools_web_client_id: '7p2s4rc837nsl12f43ha16vr08',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-titan.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-titan.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-titan.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-titan.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-titan.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-titan.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-titan.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_appsync_graphqlEndpoint: 'https://pivc6zfkwvcc5lqbjh2sbos4xe.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-titan',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
  },
  jabberwock: {
    aws_project_region: 'ap-southeast-2',
    aws_cognito_identity_pool_id: 'ap-southeast-2:a446ae1c-70b6-4247-a90a-75269ecd4845',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_PUC2BAfUT',
    aws_user_pools_web_client_id: '2htu19tvdbjuc52ae1k4mmsue9',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-jabberwock.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-jabberwock.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-jabberwock.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-jabberwock.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-jabberwock.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-jabberwock.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-jabberwock.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_appsync_graphqlEndpoint: 'https://2lo7elukfja7pnn3v5iwjuecea.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-jabberwock',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
  },
  gemini: {
    aws_project_region: 'ap-southeast-2',
    aws_cognito_identity_pool_id: 'ap-southeast-2:8cdfc172-274e-4e6a-84b8-41a21952fac6',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_ZXRx5megE',
    aws_user_pools_web_client_id: '23haj70uoo66hm798178ionai0',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-gemini.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-gemini.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-gemini.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-gemini.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-gemini.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-gemini.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-gemini.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_appsync_graphqlEndpoint: 'https://pic6co7h3vbebd6tkrqcy5vstm.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-gemini',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
  },
  laniakea: {
    aws_project_region: 'ap-southeast-2',
    aws_cognito_identity_pool_id: 'ap-southeast-2:08a60835-6dd8-41ba-8b7e-27cc9cc84269',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_Dnk0hIQz1',
    aws_user_pools_web_client_id: '108a927nviukgpctfstb2hv110',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-laniakea.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-laniakea.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-laniakea.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-laniakea.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-laniakea.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-laniakea.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-laniakea.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_appsync_graphqlEndpoint: 'https://utwgqr6uhzd4lcj2sakz3xsil4.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-laniakea',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
  },
  makemake: {
    aws_project_region: 'ap-southeast-2',
    aws_cognito_identity_pool_id: 'ap-southeast-2:f05bd6b5-f5a5-4116-9ee3-7b560931906a',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_N3vf8otag',
    aws_user_pools_web_client_id: '72luqb37vts0m1nhtga2k9fq39',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-makemake.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-makemake.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-makemake.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-makemake.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-makemake.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-makemake.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-makemake.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_appsync_graphqlEndpoint: 'https://6sz3ve6sxzdenh56eit7jwlprm.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-makemake',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
  },
  bennu: {
    aws_project_region: 'ap-southeast-2',
    aws_cognito_identity_pool_id: 'ap-southeast-2:8f9b94ad-35b6-4987-98c7-21373552444a',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_tlcLFMU07',
    aws_user_pools_web_client_id: 'tnpcgaq1e19se958gpj5stq37',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-bennu.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-bennu.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-bennu.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-bennu.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-bennu.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-bennu.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-bennu.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_appsync_graphqlEndpoint: 'https://inmdaozqhbd7fjieb2c3yjqwaq.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-bennu',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
  },
  namek: {
    aws_project_region: 'ap-southeast-2',
    aws_cognito_identity_pool_id: 'ap-southeast-2:dcde4e9d-821b-4fbd-b0fc-f37e73f21ab3',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_8f3QhWihF',
    aws_user_pools_web_client_id: '77jbvrgasjdjad5glu8ieisql',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-namek.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-namek.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-namek.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-namek.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-namek.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-namek.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-namek.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_appsync_graphqlEndpoint: 'https://4ri3ik6r3fcixb2mj3n3p4442y.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-namek',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
  },
  quacks: {
    aws_project_region: 'ap-southeast-2',
    aws_cognito_identity_pool_id: 'ap-southeast-2:73a74ecf-ef2e-4fa8-a4ca-6ac1198d3cbf',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_fhQ1eZWg7',
    aws_user_pools_web_client_id: '1to46tuhabk4ijku5dkj82u0p3',
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-quacks.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-quacks.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-quacks.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-quacks.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
    oauth: {
      domain: 'sendpayments-quacks.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-quacks.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-quacks.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_appsync_graphqlEndpoint: 'https://ghvjazvlabfqpoojjk5bt762ei.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-quacks',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
  },
  qaone: {
    ...defaultConfig,
    aws_project_region: 'ap-southeast-2',
    aws_appsync_graphqlEndpoint: 'https://zcwqmzslwfbqniapb6fqviqkme.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_cognito_identity_pool_id: 'ap-southeast-2:fdd4f229-951c-4e8b-9fff-345fb3f0db37',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_sKKsTxZXv',
    aws_user_pools_web_client_id: '7cen2bls8d8dpmncjd124nk3lu',
    oauth: {
      domain: 'sendpayments-qaone.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-qaone.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-qaone.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-qaone',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
    aws_cognito_login_mechanisms: ['EMAIL'],
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-qaone.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-qaone.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-qaone.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-qaone.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
  },
  qatwo: {
    ...defaultConfig,
    aws_project_region: 'ap-southeast-2',
    aws_appsync_graphqlEndpoint: 'https://ij2njzqw7vgqfjo5uoxmqcgq7y.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_cognito_identity_pool_id: 'ap-southeast-2:ad40a2f1-04b8-474c-8ff8-232ce3ac57d7',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_bjXNffPDn',
    aws_user_pools_web_client_id: 'sfag2fj019691skadqdkerv82',
    oauth: {
      domain: 'sendpayments-qatwo.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-qatwo.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-qatwo.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-qatwo',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
    aws_cognito_login_mechanisms: ['EMAIL'],
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-qatwo.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-qatwo.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-qatwo.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-qatwo.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
  },
  qathree: {
    ...defaultConfig,
    aws_project_region: 'ap-southeast-2',
    aws_appsync_graphqlEndpoint: 'https://ynt4vxbxvncnpayq4ylzruuyuu.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_cognito_identity_pool_id: 'ap-southeast-2:f535edd0-75a5-4cfc-99bc-01b16e3de4f1',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_7igSlmLX2',
    aws_user_pools_web_client_id: 'h4rpjola2qtsd94bgsanui01t',
    oauth: {
      domain: 'sendpayments-qathree.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-qathree.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-qathree.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-qathree',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
    aws_cognito_login_mechanisms: ['EMAIL'],
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-qathree.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-qathree.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-qathree.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-qathree.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
  },
  qafour: {
    ...defaultConfig,
    aws_project_region: 'ap-southeast-2',
    aws_appsync_graphqlEndpoint: 'https://ey5ow4z4h5ehhoak6l7sstalki.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_cognito_identity_pool_id: 'ap-southeast-2:d9ee0a7b-4dae-4d74-b1e3-9686b1cea7c7',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_ilkNPX5wk',
    aws_user_pools_web_client_id: '7qj9cunqq2j3ta6g6lgi18oevs',
    oauth: {
      domain: 'sendpayments-qafour.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-qafour.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-qafour.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-qafour',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
    aws_cognito_login_mechanisms: ['EMAIL'],
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-qafour.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-qafour.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-qafour.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-qafour.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
  },
  qafive: {
    ...defaultConfig,
    aws_project_region: 'ap-southeast-2',
    aws_appsync_graphqlEndpoint: 'https://ale3rhqunney3ew3zgek22wpge.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_cognito_identity_pool_id: 'ap-southeast-2:c6d3ed6b-6a9d-46ce-b784-b037125f9338',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_O6Yjm4Sg7',
    aws_user_pools_web_client_id: '3ud4qp4d8sn94t89o9r4kddegv',
    oauth: {
      domain: 'sendpayments-qafive.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-qafive.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-qafive.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-qafive',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
    aws_cognito_login_mechanisms: ['EMAIL'],
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-qafive.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-qafive.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-qafive.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-qafive.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
  },
  qasix: {
    ...defaultConfig,
    aws_project_region: 'ap-southeast-2',
    aws_appsync_graphqlEndpoint: 'https://4shmmuyahzf6hezty7ignfcdcy.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_cognito_identity_pool_id: 'ap-southeast-2:3ec461f8-cb09-4acb-947b-58280fe86e18',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_QoxF4f4PY',
    aws_user_pools_web_client_id: '3217bpmejpi22244fsdvsq3b8i',
    oauth: {
      domain: 'sendpayments-qasix.auth.ap-southeast-2.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://localhost:9000/,https://portal-qasix.env.sendfx.net/',
      redirectSignOut: 'https://localhost:9000/,https://portal-qasix.env.sendfx.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OPTIONAL',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_user_files_s3_bucket: 'coconut0f9cd27443a347069c6952e291b8bb74-qasix',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
    aws_cognito_login_mechanisms: ['EMAIL'],
    aws_cloud_logic_custom: [
      {
        name: 'SendApi',
        endpoint: 'https://api-qasix.env.sendfx.net',
        region: 'ap-southeast-2',
      },
      {
        name: 'InternalApi',
        endpoint: 'https://internal-api-qasix.env.sendpayments.com',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerApi',
        endpoint: 'https://ledger-qasix.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
      {
        name: 'LedgerAPIv2',
        endpoint: 'https://ledger-v2-api-qasix.env.sendpayments.com/v1',
        region: 'ap-southeast-2',
      },
    ],
  },
};

module.exports = awsenvconfig;
